import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable()
export class ActivatedRouteServiceMock {
  params = of({ id: 92 });
  queryParams = of({});
  queryParamMap = of(new Map());
  snapshot = {
    url: [],
    routeConfig: {},
    data: {},
    paramMap: {
      get: () => 2,
    },
    queryParamMap: {
      get: () => null,
    },
  };

  navigate() {
    return null;
  }
}
